import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import AuthCallback from "./pages/AuthCallback";
import Landing from "./pages/Landing";
import Onboarding from "./pages/Onboarding";
import NatalReveal from "./pages/NatalReveal";
import Dashboard from "./pages/Dashboard";
import Scanner from "./pages/Scanner";
import Chat from "./pages/Chat";
import PostcardShare from "./pages/PostcardShare";
import { Toaster } from "sonner";
import NavBar from "./components/NavBar";
import "./App.css";

function ProtectedRoute({ children, requireNatal = true }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted" data-testid="loading-state">Aligning constellations…</div>;
  if (!user) return <Navigate to="/" replace />;
  if (requireNatal && !user.natal) return <Navigate to="/onboarding" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/postcard/:slug" element={<PostcardShare />} />
      <Route path="/onboarding" element={
        <ProtectedRoute requireNatal={false}><Onboarding /></ProtectedRoute>
      } />
      <Route path="/reveal" element={
        <ProtectedRoute><NatalReveal /></ProtectedRoute>
      } />
      <Route path="/dashboard" element={
        <ProtectedRoute><Shell><Dashboard /></Shell></ProtectedRoute>
      } />
      <Route path="/scanner" element={
        <ProtectedRoute><Shell><Scanner /></Shell></ProtectedRoute>
      } />
      <Route path="/chat" element={
        <ProtectedRoute><Shell><Chat /></Shell></ProtectedRoute>
      } />
      <Route path="/chat/:kind/:id" element={
        <ProtectedRoute><Shell><Chat /></Shell></ProtectedRoute>
      } />
      <Route path="/leaderboard" element={<Navigate to="/scanner" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function Shell({ children }) {
  return (
    <div className="min-h-screen relative">
      <div className="starfield" />
      <div className="noise" />
      <NavBar />
      <main className="relative z-10 max-w-6xl mx-auto px-4 sm:px-8 pb-24 pt-4 sm:pt-6">
        {children}
      </main>
    </div>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
